import React from 'react';
import DeleteUserForm from '@/Domains/Profile/DeleteUserForm';
import LogoutOtherBrowserSessions from '@/Domains/Profile/LogoutOtherBrowserSessionsForm';
import TwoFactorAuthenticationForm from '@/Domains/Profile/TwoFactorAuthenticationForm';
import UpdatePasswordForm from '@/Domains/Profile/UpdatePasswordForm';
import UpdateProfileInformationForm from '@/Domains/Profile/UpdateProfileInformationForm';
import AppLayout from '@/Layouts/AppLayout';
import { usePage } from '@inertiajs/react';
import { motion } from 'framer-motion';
import SectionBorder from '../../Components/Surfaces/SectionBorder';

export default function Show({ sessions, confirmsTwoFactorAuthentication }) {
  const page = usePage();

  const animateProfile = {
    initial: { opacity: 1 },
    animate: { opacity: 1 },
  };

  return (
    <AppLayout title="Profile">
      <motion.div
        variants={animateProfile}
        initial="initial"
        animate="animate"
        exit="exit"
      >
        <div className="mx-auto w-full max-w-screen-md">
          {page.props.jetstream.canUpdateProfileInformation ? (
            <div>
              <UpdateProfileInformationForm user={page.props.user} />
              <SectionBorder />
            </div>
          ) : null}
          {page.props.jetstream.canUpdatePassword ? (
            <div className="mt-10 sm:mt-0">
              <UpdatePasswordForm />
              <SectionBorder />
            </div>
          ) : null}
          {page.props.jetstream.canManageTwoFactorAuthentication ? (
            <div className="">
              <TwoFactorAuthenticationForm
                requiresConfirmation={confirmsTwoFactorAuthentication}
              />
              <SectionBorder />
            </div>
          ) : null}
          <div className="mt-10 sm:mt-0">
            <LogoutOtherBrowserSessions sessions={sessions} />
          </div>
          {page.props.jetstream.hasAccountDeletionFeatures ? (
            <div>
              <SectionBorder />
              <div className="mt-10 sm:mt-0">
                <DeleteUserForm />
              </div>
            </div>
          ) : null}
        </div>
      </motion.div>
    </AppLayout>
  );
}
